import { apiUrlcommon, apiUrl } from './../app.config';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import {
  Http,
  Response,
  URLSearchParams,
  Headers,
  RequestOptionsArgs,
  RequestOptions
} from '@angular/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from './data.service';

@Injectable()
export class GlobalvariableService {
  public defaultHeaders: Headers = new Headers();
  public gengovalue: any;
  constructor(private _http: Http, private router: Router, private _data: DataService) {
    this.gengovalue = this._http
      .request(
        `${apiUrlcommon}` + `/etc/kbn/gengoKbn`,
        this.getRequestOptions()
      )
      .map((response: Response) => {
        if (response.status === 204) {
          return undefined;
        } else {
          return response.json();
        }
      })
      .publishReplay(1)
      .refCount()
      .catch(this.handleError.bind(this));
  }

  getRequestOptions() {
    const queryParameters = new URLSearchParams();
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    const requestOptions: RequestOptionsArgs = {
      method: 'GET',
      headers: headerParams,
      search: queryParameters
    };

    return requestOptions;
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    if (error.status === 401) {
      this.deleteToken();
    } else {
      return Observable.throw(errMsg);
    }
  }

  deleteToken() {
    const headerParams = this.defaultHeaders;
    headerParams.set('auth', this._data.token);
    if (this._data.token !== null) {
      this.clearDataAndNavigateToLogin();
      return this._http
        .delete(`${apiUrl}/auth/token`, { headers: headerParams })
        .subscribe(() => {});
    }
  }

  clearDataAndNavigateToLogin() {
    this._data.clearData();
    // location.reload();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/globalvariable.service.ts